module.exports = __webpack_public_path__ + "static/media/fbstart.ca8a79fa.png";